import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DigipoortFlow } from 'src/app/constants/digipoort-flow.enum';

@Component({
  selector: 'app-digipoort-modal',
  templateUrl: './digipoort-modal.component.html',
  styleUrls: ['./digipoort-modal.component.css']
})
export class DigipoortModal {
  @Input() digipoort: string = 'Productie';
  @Input() flow: DigipoortFlow = DigipoortFlow.Happyflow;
  @Input() environment!: any;
  @Output() updateOrganisationSettings: EventEmitter<any> = new EventEmitter<any>();
  public digipoortFlow;

  constructor(private activeModal: NgbActiveModal) {
    this.digipoortFlow = DigipoortFlow;
  }

  save() {
    this.updateOrganisationSettings.emit([{ key: 'DigipoortEnvironment', value: this.digipoort }, { key: 'AansluitSuiteAanleverKenmerk', value: this.flow ?? "" }]);
  }

  updateValue(value: string): void {
    this.digipoort = value;
  }

  updateFlow(value: string): void {
    this.flow = value as DigipoortFlow;
  }

  closeDialog() {
    this.activeModal.close(false);
  }
}
